<template>
  <div class="past-events-container collapsible-section">
    <h3 @click="toggleOpen" class="collapsible-header">
      Istoric Evenimente
      <span>{{ isOpen ? '▲' : '▼' }}</span>
    </h3>
    
    <div v-if="isOpen" class="collapsible-content">
      
      <div class="total-hours-card">
        <h4>Total Ore Confirmate</h4>
        <div class="total-hours-value">{{ totalHours }} ore</div>
      </div>
      <div v-if="loading">Se încarcă istoricul...</div>
      
      <div v-if="error" class="error">{{ error }}</div>
      
      <ul v-if="events.length > 0" class="event-list">
        <li v-for="event in events" :key="event.id" class="event-item">
          <h4>{{ event.title }}</h4>
          <p><strong>Dată:</strong> {{ formatData(event.start_time) }}</p>
          
          <div v-if="event.confirmation_status === 'attended'">
            <p><strong>Status:</strong> <span class="status-attended">Participat</span></p>
            <p><strong>Ore primite:</strong> {{ event.duration_hours }}</p>
          </div>
          <div v-else>
            <p><strong>Status:</strong> <span class="status-missed">Absent</span></p>
          </div>

        </li>
      </ul>
      
      <p v-if="!loading && events.length === 0">Nu ai participat la niciun eveniment încă.</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'; 
import apiClient from '@/api.js';

// Dropdown state
const isOpen = ref(true); 
const toggleOpen = () => { isOpen.value = !isOpen.value; };

// Stare
const events = ref([]);
const loading = ref(true);
const error = ref('');

// Proprietate 'computed' pentru a calcula totalul orelor
const totalHours = computed(() => {
  return events.value.reduce((total, event) => {
    // 
    // AICI ESTE CORECȚIA LA SCRIPT:
    // Am schimbat 'event.status' în 'event.confirmation_status'
    //
    if (event.confirmation_status === 'attended') {
      return total + parseFloat(event.duration_hours || 0);
    }
    return total;
  }, 0); 
});

// Formatare dată
const formatData = (isoString) => {
  return new Date(isoString).toLocaleString('ro-RO', {
    dateStyle: 'medium',
    timeStyle: 'short'
  });
};

// Preluăm istoricul la încărcare
onMounted(async () => {
  try {
    const response = await apiClient.get('/profile/my-past-events');
    events.value = response.data;
  } catch (err) {
    console.error("Eroare la preluarea istoricului:", err);
    error.value = 'Nu am putut încărca istoricul.';
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
/* Stilurile tale originale (sunt bune) */
.past-events-container {
  margin-top: 30px;
}
.collapsible-header {
  cursor: pointer; display: flex; justify-content: space-between;
  align-items: center; border-bottom: 2px solid #6c757d; 
  padding-bottom: 10px; margin: 0;
}
.collapsible-header:hover { background-color: #f8f9fa; }
.collapsible-header span { font-size: 0.8em; }
.collapsible-content { padding-top: 20px; }
.event-list { list-style-type: none; padding: 0; }
.event-item {
  border: 1px solid #eee; background-color: #f9f9f9;
  padding: 15px; margin-bottom: 15px; border-radius: 8px;
  opacity: 0.8; 
}
.event-item h4 { margin-top: 0; color: #333; }
.error { color: red; }
.status-attended {
  font-weight: bold;
  color: #28a745;
}
.status-missed {
  font-weight: bold;
  color: #dc3545;
}

/* STILURILE NOI PENTRU CARD-UL DE TOTAL 
*/
.total-hours-card {
  background-color: #0E3035; /* Albastru Închis OSACE */
  color: white;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 25px;
  text-align: center;
}
.total-hours-card h4 {
  margin: 0 0 10px 0;
  font-weight: 500;
  color: #f7f7f7;
}
.total-hours-value {
  font-size: 2.5em;
  font-weight: bold;
}
</style>